module.exports = __webpack_public_path__ + "media/CN_011.7d048489.mp3";